<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Enviar orçamento"
    type-modal="send_whats_quotation_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="print()">

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Telefone</label>
            <d-form-input type="email" id="feInputFooter" v-model="model.phone" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem de envio</label>
            <textarea class="form-control" rows="10" v-model="model.sendMessageWhats"></textarea>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="send()"
        class="btn btn-sm btn-primary"
      >Enviar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinFormatMessage from '_common/mixins/FormatMessage';
import { _OPEN_MODAL_, MODEL } from '../QuotationModel';

export default {
  name: 'send-whatsapp',
  data() {
    return {
      loading: false,
      model: {
        phone: '',
        sendMessageWhats: '',
      },
      quotation: { ...MODEL },
    };
  },
  mixins: [MixinFormatMessage],
  components: {
    ModalTemplate,
  },
  computed: {
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        return messages;
      }
      return { sendMessageWhats: '' };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    formatMessages() {
      const message = this.setCustomerMessage(this.messages.sendMessageWhats, this.quotation.customer);
      this.model.phone = this.quotation.customer_phone;
      this.model.sendMessageWhats = this.setSellerMessage(message, this.quotation);
    },
    openLink(response) {
      const popUp = window.open(response, '_blank');
      if (!popUp || typeof (popUp) === 'undefined') {
        alert('Os popup do seu navegador estão bloqueados'); // eslint-disable-line
      } else {
        popUp.focus();
      }
    },
    send() {
      this.setToggle({ type: 'progress', bool: true });
      const params = { message: this.model.sendMessageWhats, phone: this.model.phone, quotation_id: this.quotation.id };
      QuotationService.sendMessageWhats(params)
        .then(response => {
          this.openLink(response);
          this.setToggle({ type: 'send_whats_quotation_modal', bool: false });
          this.activeAlert({ message: 'Orçamento enviado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'send_whats_quotation_modal') {
        this.quotation = quotation;
        if (this.quotation) {
          this.getSettingsSystem();
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
